var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// components/icon-font/common/src/icon-style-sheet.ts
import {
  StyleSheet,
  getEmotionInstance
} from "@gs-ux-uitoolkit-common/style";

// components/icon-font/common/src/props.ts
var iconTypes = ["filled", "outlined"];
var iconSizes = ["sm", "md", "lg"];
var defaultIconProps = {
  size: "md",
  type: "filled"
};

// components/icon-font/common/src/util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";

// components/icon-font/common/src/generated/fonts.ts
var materialSymbolsFontFamily = "Material Symbols Outlined";
var customIconFontFamily = "CustomIcons";
function getCodePointFromIconName(name) {
  return name.replace(/-/g, "_");
}

// components/icon-font/common/src/design-system-icons/custom-icon-set.ts
var customFilledIcons = {
  brand: ["gs-logo-box", "gs-logo-sig", "mq-logo", "mq-logo-full"],
  grid: [
    "grid-child-bottom",
    "grid-child-middle",
    "grid-child-pipe",
    "grid-child-top-point",
    "grid-child-top",
    "grid-collapse",
    "grid-delta-negative",
    "grid-delta-positive",
    "grid-expand",
    "grid-hide-children",
    "grid-input-resizing",
    "grid-large",
    "grid-reorder-column",
    "grid-reorder-row",
    "grid-show-children",
    "grid-table-columns",
    "grid-table-rows"
  ],
  marquee: [
    "mq-angel",
    "mq-asset",
    "mq-aurora-developer",
    "mq-client-hub",
    "mq-commentary",
    "mq-data-services",
    "mq-devil",
    "mq-down-arrow",
    "mq-enable-1-click",
    "mq-enhanced-trading-grid",
    "mq-hammer",
    "mq-hedge",
    "mq-hedging",
    "mq-intelligence",
    "mq-investment",
    "mq-iselect-customize",
    "mq-ladder",
    "mq-left-axis",
    "mq-light-bulb-off",
    "mq-light-bulb-on",
    "mq-log-out",
    "mq-logo-full",
    "mq-logo",
    "mq-metrics",
    "mq-moon",
    "mq-network",
    "mq-order-blotter-2",
    "mq-order-blotter",
    "mq-platform-profile",
    "mq-plottool",
    "mq-portfolio-choose-type-credit",
    "mq-portfolio-choose-type-equity",
    "mq-portfolio",
    "mq-rebalance",
    "mq-research-home",
    "mq-right-axis",
    "mq-save-as-workspace",
    "mq-single-trading-tile",
    "mq-sun",
    "mq-ticket",
    "mq-trading-blotter",
    "mq-trading-tiles",
    "mq-trend-down",
    "mq-trend-up",
    "mq-up-arrow"
  ],
  toolkit: [
    "add-shopping-basket",
    "alteryx",
    "angular",
    "arrow-left-right",
    "arrow-up-down",
    "aspen",
    "auto-fix",
    "bullseye",
    "calculator",
    "calendar-clock",
    "calendar-minus",
    "calendar-plus",
    "chart-areaspline",
    "chart-bar",
    "chart-line",
    "chevron-double-down",
    "chevron-double-left",
    "chevron-double-right",
    "chevron-double-up",
    "clipboard",
    "close-box",
    "currency-eur",
    "currency-gbp",
    "currency-inr",
    "currency-jpy",
    "currency-krw",
    "currency-rub",
    "currency-usd",
    "cursor-default",
    "database",
    "deal-harbor",
    "emoji-events",
    "facebook",
    "factory",
    "file-code",
    "file-document-edit",
    "file-document",
    "file-excel",
    "file-image",
    "file-multiple",
    "file-pdf",
    "file-powerpoint",
    "file-word",
    "file",
    "flask",
    "folder-open-variant",
    "grid-large",
    "gs-equal",
    "highlight_alt",
    "honest-dollar",
    "instagram",
    "lithium",
    "linkedin",
    "loading",
    "login-variant",
    "logout-variant",
    "metric-arrow-drop-down",
    "metric-arrow-drop-up",
    "motion-photos-on",
    "powerbi",
    "priority-high-gs",
    "qlik",
    "qliksense",
    "qlikview",
    "quicksight",
    "rapidminer",
    "react",
    "real-estate",
    "road-variant",
    "roae",
    "server",
    "share-variant",
    "sitemap",
    "skip-left",
    "skip-right",
    "sort-ascending-variant",
    "sort-descending-variant",
    "sort-variant",
    "snapchat",
    "square-variant",
    "symphony",
    "table",
    "tableau",
    "tag-multiple",
    "tiktok",
    "twitter",
    "vector-polyline",
    "window-maximize",
    "window-minimize",
    "window-restore",
    "x",
    "youtube"
  ]
};
var customOutlinedIcons = {
  brand: ["gs-logo-box"],
  grid: [],
  marquee: [],
  toolkit: [
    "add-shopping-basket",
    "emoji-events",
    "file-code",
    "file-document-edit",
    "file-document",
    "file-excel",
    "file-image",
    "file-multiple",
    "file-pdf",
    "file-powerpoint",
    "file-word",
    "file",
    "folder-open-variant",
    "highlight_alt",
    "motion-photos-on",
    "square-variant",
    "tag-multiple"
  ]
};
var customIconMap = createCustomIconMap();
function createCustomIconMap() {
  const customIconMap2 = {};
  const customIcons = Array.from(
    /* @__PURE__ */ new Set([
      ...customFilledIcons.brand,
      ...customFilledIcons.grid,
      ...customFilledIcons.marquee,
      ...customFilledIcons.toolkit,
      ...customOutlinedIcons.brand,
      ...customOutlinedIcons.grid,
      ...customOutlinedIcons.marquee,
      ...customOutlinedIcons.toolkit
    ])
  );
  customIcons.forEach((iconName) => customIconMap2[iconName] = true);
  return customIconMap2;
}

// components/icon-font/common/src/icon-to-fonts.ts
function resolveIconFont(props) {
  const { name } = props;
  if (isCustomIcon(name)) {
    return "custom";
  }
  return "materialSymbols";
}
function isCustomIcon(name) {
  return customIconMap[name] || false;
}

// components/icon-font/common/src/design-system-icons/v16-to-v17-outlined-icon-mapping.ts
var v16ToV17IconMapping = {
  "add-circle": "add-circle-outline",
  bookmark: "bookmark-border",
  "chat-bubble": "chat-bubble-outline",
  error: "error-outline",
  favorite: "favorite-border",
  help: "help-outline",
  mic: "mic-none",
  "remove-circle": "remove-circle-outline",
  star: "star-outline",
  warning: "warning-amber",
  work: "work-outline"
};

// components/icon-font/common/src/resolve-icon-from-v16.ts
function resolveIconFromV16IconName(iconName) {
  return v16ToV17IconMapping[iconName] || iconName;
}

// components/icon-font/common/src/design-system-icons/v17-to-v18-icon-mapping.ts
var v17ToV18IconMapping = {
  "play-circle-filled": "play-circle",
  "play-circle-outline": "play-circle",
  "person-add-alt-1": "person-add",
  "person-remove-alt-1": "person-remove",
  "no-cell": "mobile-off",
  outbond: "outbound",
  paste: "content-paste"
};

// components/icon-font/common/src/resolve-icon-from-v17.ts
function resolveIconFromV17IconName(iconName) {
  return v17ToV18IconMapping[iconName] || iconName;
}

// components/icon-font/common/src/util.ts
var getIconClassNames = (props) => {
  const { cssClasses: classes, className, overrideClasses } = props;
  return cx(classes.root, className, overrideClasses && overrideClasses.root, "gs-icon");
};
var getIconContentClassNames = (props) => {
  const { cssClasses: classes, overrideClasses } = props;
  return cx(classes.content, overrideClasses && overrideClasses.content);
};
function getIconCodePoint(props) {
  const { name, type } = props;
  const font = resolveIconFont(props);
  if (font === "custom" && type === "outlined") {
    const outlinedSuffix = "-outline";
    const iconName = name + outlinedSuffix;
    return getCodePointFromIconName(iconName);
  }
  return getCodePointFromIconName(name);
}
function getAriaLabel(iconName) {
  return iconName.split("-").map((str) => str.charAt(0).toUpperCase() + str.substr(1).toLowerCase()).join(" ");
}
var resolveIconName = (name) => {
  return resolveIconFromV17IconName(resolveIconFromV16IconName(name));
};

// components/icon-font/common/src/font-loading-store.ts
import FontFaceObserver from "fontfaceobserver-es";
import {
  kebabCase,
  isTestEnv,
  logWarningOnce,
  isBrowser,
  isIE
} from "@gs-ux-uitoolkit-common/shared";
var fontState = {};
var FontLoadingStore = class {
  constructor() {
  }
  static getFont(fontFamily) {
    if (!isBrowser || isIE)
      return null;
    if (!fontState[fontFamily]) {
      addBodyLoadingClass({ fontFamily });
      fontState[fontFamily] = {
        loaded: false,
        loadPromise: new FontFaceObserver(fontFamily).load(void 0, 3e4).then(
          () => {
            fontState[fontFamily].loaded = true;
            removeBodyLoadingClass({ fontFamily });
          },
          (error) => {
            if (!isTestEnv()) {
              logWarningOnce(`Font ${fontFamily} cannot be loaded: ${error}`);
            }
          }
        )
      };
    }
    return fontState[fontFamily];
  }
};
function addBodyLoadingClass(props) {
  const { fontFamily } = props;
  const bodyClasses = document.body.classList;
  const fontLoadedClass = getIconFontLoadingClass({ fontFamily });
  if (!bodyClasses.contains(fontLoadedClass)) {
    bodyClasses.add(fontLoadedClass);
  }
}
function removeBodyLoadingClass(props) {
  const { fontFamily } = props;
  const bodyClasses = document.body.classList;
  const fontLoadedClass = getIconFontLoadingClass({ fontFamily });
  bodyClasses.remove(fontLoadedClass);
}
function getIconFontLoadingClass(props) {
  return `gs-uitk-icon-font-loading-${kebabCase(props.fontFamily)}`;
}

// components/icon-font/common/src/icon-font-faces.ts
import { injectFont } from "@gs-ux-uitoolkit-common/style";
import { getCdnBaseUrl } from "@gs-ux-uitoolkit-common/design-system";
var iconFontFamilies = {
  materialSymbols: materialSymbolsFontFamily,
  custom: customIconFontFamily
};
var iconFontSizes = {
  sm: "16px",
  md: "20px",
  lg: "24px"
};
var iconFontWeight = 900;
var fontFaces = getFontFaces();
var materialDesignIconFonts = fontFaces;
function getFontFaces() {
  const fontBaseUrl = `${getCdnBaseUrl()}/fonts/gs-ux-uitoolkit-icons/v7`;
  return [
    {
      family: iconFontFamilies["materialSymbols"],
      weight: 900,
      style: "normal",
      src: [`${fontBaseUrl}/material-symbols-outlined/material-symbols-outlined.woff2`]
    },
    {
      family: iconFontFamilies["custom"],
      weight: 900,
      style: "normal",
      src: [
        `${fontBaseUrl}/custom-icons/custom-icons.woff2`,
        `${fontBaseUrl}/custom-icons/custom-icons.woff`
        // Comment above two lines and uncomment below two lines to test
        // out local changes to custom fonts after following instructions here:
        // https://gitlab.aws.site.gs.com/wf/mwp-ui/gs-ux-uitoolkit/-/wikis/Components/Iconography
        //`http://localhost:9000/CustomIcons.woff2`,
        //`http://localhost:9000/CustomIcons.woff`,
      ]
    }
  ];
}
var hasInjectedIconFonts = false;
function injectIconFonts() {
  if (!hasInjectedIconFonts) {
    getFontFaces().forEach((fontFace) => injectFont(fontFace));
    hasInjectedIconFonts = true;
  }
}

// components/icon-font/common/src/icon-style-sheet.ts
import { createComponentClassDefinitions } from "@gs-ux-uitoolkit-common/theme";
var iconStyleSheet = new StyleSheet("icon", (props) => {
  var _a;
  return createComponentClassDefinitions(
    props,
    createDefaultStyledClasses,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.icon
  );
});
function createDefaultStyledClasses({
  fontFamily,
  size,
  type,
  spin,
  pulse,
  loading
}) {
  return {
    root: __spreadValues(__spreadValues({}, getBaseIconStyles({ fontFamily, size, type })), loading && getLoadingStyles(size)),
    content: __spreadValues(__spreadValues({
      // 'inline-block' required for css 'transform' to work https://stackoverflow.com/questions/4919963/css3-transform-not-working
      display: "inline-block"
    }, spin && getSpinStyles()), pulse && getPulseStyles())
  };
}
function getBaseIconStyles(props) {
  injectIconFonts();
  const { fontFamily, size = defaultIconProps.size, type = defaultIconProps.type } = props;
  FontLoadingStore.getFont(fontFamily);
  const fontVariationSettings = `'FILL' ${type === "filled" ? 1 : 0}, 'wght' 300, 'GRAD' 0, 'opsz' 24`;
  const baseIconStyles = {
    fontStyle: "normal",
    lineHeight: "1",
    letterSpacing: "normal",
    textTransform: "none",
    display: "inline-block",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    direction: "ltr",
    fontFeatureSettings: '"liga"',
    WebkitFontFeatureSettings: '"liga"',
    MozFontFeatureSettings: '"liga"',
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
    fontFamily,
    fontWeight: iconFontWeight,
    fontSize: iconFontSizes[size],
    verticalAlign: "bottom",
    // vertically centers the icon with the text
    fontVariationSettings
  };
  const fontLoadingStyles = {
    visibility: "hidden",
    width: iconFontSizes[size],
    height: iconFontSizes[size]
  };
  return __spreadProps(__spreadValues({}, baseIconStyles), {
    [`.${getIconFontLoadingClass({ fontFamily })} &`]: __spreadValues({}, fontLoadingStyles)
  });
}
var getIconStyles = (props) => {
  const _a = props, { size } = _a, icon = __objRest(_a, ["size"]);
  const fontFamily = resolveFontFamily(icon);
  return __spreadValues({
    content: `"${getIconCodePoint(icon)}"`
  }, getBaseIconStyles({ fontFamily, size, type: icon.type }));
};
function resolveFontFamily(props) {
  const resolvedFont = resolveIconFont(props);
  return resolvedFont ? iconFontFamilies[resolvedFont] : "";
}
function getSpinStyles() {
  const spin = getEmotionInstance().keyframes`
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    `;
  return {
    animation: `${spin} 2s infinite linear`,
    display: "inline-block"
    // required for css 'transform' to work https://stackoverflow.com/questions/4919963/css3-transform-not-working
  };
}
function getPulseStyles() {
  const pulse = getEmotionInstance().keyframes`
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    `;
  return {
    animation: `${pulse} 1s infinite steps(8)`,
    display: "inline-block"
    // required for css 'transform' to work https://stackoverflow.com/questions/4919963/css3-transform-not-working
  };
}
function getLoadingStyles(size) {
  return {
    width: iconFontSizes[size],
    height: iconFontSizes[size],
    visibility: "hidden"
  };
}

// components/icon-font/common/src/status-icons.ts
var statusIcons = {
  none: {
    name: "info",
    type: "outlined"
  },
  information: {
    name: "info",
    type: "outlined"
  },
  success: {
    name: "check-circle",
    type: "outlined"
  },
  warning: {
    name: "warning",
    type: "outlined"
  },
  error: {
    name: "error",
    type: "outlined"
  },
  loading: {
    name: "loading",
    type: "filled"
  }
};

// components/icon-font/common/src/design-system-icons/v12-to-design-system-icon-mapping.ts
var v12ToDesignSystemIconMapping = {
  account: { name: "person", type: "filled" },
  "account-group": { name: "groups", type: "filled" },
  alert: { name: "warning", type: "filled" },
  "alert-circle": { name: "error", type: "filled" },
  "alert-circle-outline": { name: "error", type: "outlined" },
  "alert-outline": { name: "warning", type: "outlined" },
  angular: { name: "angular", type: "filled" },
  "arrow-all": { name: "open-with", type: "filled" },
  "arrow-down": { name: "arrow-downward", type: "filled" },
  "arrow-expand-all": { name: "zoom-out-map", type: "filled" },
  "arrow-left": { name: "arrow-back", type: "filled" },
  "arrow-left-right": { name: "arrow-left-right", type: "filled" },
  "arrow-right": { name: "arrow-forward", type: "filled" },
  "arrow-up": { name: "arrow-upward", type: "filled" },
  "arrow-up-down": { name: "arrow-up-down", type: "filled" },
  aspen: { name: "aspen", type: "filled" },
  at: { name: "alternate-email", type: "filled" },
  "auto-fix": { name: "auto-fix", type: "filled" },
  bell: { name: "notifications", type: "filled" },
  book: { name: "book", type: "filled" },
  bookmark: { name: "bookmark", type: "filled" },
  "bookmark-outline": { name: "bookmark", type: "outlined" },
  briefcase: { name: "work", type: "filled" },
  brush: { name: "brush", type: "filled" },
  bug: { name: "bug-report", type: "filled" },
  bullseye: { name: "bullseye", type: "filled" },
  calculator: { name: "calculator", type: "filled" },
  "calendar-blank": { name: "calendar-today", type: "filled" },
  "calendar-minus": { name: "calendar-minus", type: "filled" },
  "calendar-plus": { name: "calendar-plus", type: "filled" },
  camera: { name: "photo-camera", type: "filled" },
  cancel: { name: "block", type: "filled" },
  cellphone: { name: "smartphone", type: "filled" },
  "chart-areaspline": { name: "chart-areaspline", type: "filled" },
  "chart-bar": { name: "chart-bar", type: "filled" },
  "chart-line": { name: "chart-line", type: "filled" },
  "chart-pie": { name: "pie-chart", type: "filled" },
  check: { name: "check", type: "filled" },
  "check-circle-outline": { name: "check-circle", type: "outlined" },
  "checkbox-marked": { name: "check-box", type: "filled" },
  "checkbox-marked-circle": { name: "check-circle", type: "filled" },
  "chevron-double-down": { name: "chevron-double-down", type: "filled" },
  "chevron-double-left": { name: "chevron-double-left", type: "filled" },
  "chevron-double-right": { name: "chevron-double-right", type: "filled" },
  "chevron-double-up": { name: "chevron-double-up", type: "filled" },
  "chevron-down": { name: "keyboard-arrow-down", type: "filled" },
  "chevron-left": { name: "keyboard-arrow-left", type: "filled" },
  "chevron-right": { name: "keyboard-arrow-right", type: "filled" },
  "chevron-up": { name: "keyboard-arrow-up", type: "filled" },
  circle: { name: "lens", type: "filled" },
  "circle-outline": { name: "panorama-fish-eye", type: "filled" },
  clipboard: { name: "clipboard", type: "filled" },
  clock: { name: "watch-later", type: "filled" },
  "clock-outline": { name: "watch-later", type: "outlined" },
  close: { name: "close", type: "filled" },
  "close-box": { name: "close-box", type: "filled" },
  "close-circle": { name: "cancel", type: "filled" },
  "cloud-download": { name: "cloud-download", type: "filled" },
  "cloud-upload": { name: "cloud-upload", type: "filled" },
  "code-tags": { name: "code", type: "filled" },
  comment: { name: "chat-bubble", type: "filled" },
  "comment-multiple": { name: "forum", type: "filled" },
  "content-save": { name: "save", type: "filled" },
  "credit-card": { name: "credit-card", type: "filled" },
  "currency-eur": { name: "currency-eur", type: "filled" },
  "currency-gbp": { name: "currency-gbp", type: "filled" },
  "currency-inr": { name: "currency-inr", type: "filled" },
  "currency-jpy": { name: "currency-jpy", type: "filled" },
  "currency-krw": { name: "currency-krw", type: "filled" },
  "currency-rub": { name: "currency-rub", type: "filled" },
  "currency-usd": { name: "currency-usd", type: "filled" },
  "cursor-default": { name: "cursor-default", type: "filled" },
  database: { name: "database", type: "filled" },
  "deal-harbor": { name: "deal-harbor", type: "filled" },
  delete: { name: "delete", type: "filled" },
  "dots-horizontal": { name: "more-horiz", type: "filled" },
  "dots-vertical": { name: "more-vert", type: "filled" },
  download: { name: "download", type: "filled" },
  email: { name: "email", type: "filled" },
  exclamation: { name: "priority-high", type: "filled" },
  eye: { name: "visibility", type: "filled" },
  "eye-off": { name: "visibility-off", type: "filled" },
  factory: { name: "factory", type: "filled" },
  file: { name: "file", type: "filled" },
  "file-code": { name: "file", type: "filled" },
  "file-document": { name: "file-document", type: "filled" },
  "file-document-edit-outline": { name: "file-document-edit", type: "outlined" },
  "file-image": { name: "file-image", type: "filled" },
  "file-multiple": { name: "file-multiple", type: "filled" },
  "file-pdf": { name: "file-pdf", type: "filled" },
  filter: { name: "filter-list", type: "filled" },
  flag: { name: "flag", type: "filled" },
  flash: { name: "flash-on", type: "filled" },
  flask: { name: "flask", type: "filled" },
  folder: { name: "folder", type: "filled" },
  "folder-account": { name: "folder-shared", type: "filled" },
  "folder-open": { name: "folder-open", type: "filled" },
  "format-align-center": { name: "format-align-center", type: "filled" },
  "format-align-left": { name: "format-align-left", type: "filled" },
  "format-align-right": { name: "format-align-right", type: "filled" },
  "format-bold": { name: "format-bold", type: "filled" },
  "format-italic": { name: "format-italic", type: "filled" },
  "format-list-bulleted": { name: "format-list-bulleted", type: "filled" },
  "format-list-bulleted-square": { name: "format-list-bulleted", type: "filled" },
  // square bullet is deprecated, pointing to round for backwards compatibility
  "format-list-numbered": { name: "format-list-numbered", type: "filled" },
  "format-quote-close": { name: "format-quote", type: "filled" },
  "format-underline": { name: "format-underlined", type: "filled" },
  grid: { name: "grid-on", type: "filled" },
  "grid-large": { name: "grid-large", type: "filled" },
  heart: { name: "favorite", type: "filled" },
  "heart-outline": { name: "favorite", type: "outlined" },
  help: { name: "help", type: "filled" },
  // plain question mark 'help' is deprecated, pointing to new 'help' for backwards compatibility
  "help-circle": { name: "help", type: "filled" },
  history: { name: "history", type: "filled" },
  home: { name: "home", type: "filled" },
  "honest-dollar": { name: "honest-dollar", type: "filled" },
  image: { name: "image", type: "filled" },
  "image-multiple": { name: "photo-library", type: "filled" },
  inbox: { name: "inbox", type: "filled" },
  information: { name: "info", type: "filled" },
  "information-outline": { name: "info", type: "outlined" },
  "information-variant": { name: "info", type: "filled" },
  // info variant is deprecated, pointing to 'info' for backwards compatibility
  keyboard: { name: "keyboard", type: "filled" },
  lightbulb: { name: "lightbulb", type: "filled" },
  link: { name: "link", type: "filled" },
  "link-off": { name: "link-off", type: "filled" },
  lithium: { name: "lithium", type: "filled" },
  loading: { name: "loading", type: "filled" },
  lock: { name: "lock", type: "filled" },
  "lock-open": { name: "lock-open", type: "filled" },
  login: { name: "login-variant", type: "filled" },
  logout: { name: "logout-variant", type: "filled" },
  magnify: { name: "search", type: "filled" },
  "magnify-minus-outline": { name: "zoom-out", type: "filled" },
  "magnify-plus-outline": { name: "zoom-in", type: "filled" },
  "map-marker": { name: "location-pin", type: "filled" },
  menu: { name: "menu", type: "filled" },
  "menu-down": { name: "arrow-drop-down", type: "filled" },
  "menu-left": { name: "arrow-left", type: "filled" },
  "menu-right": { name: "arrow-right", type: "filled" },
  "menu-up": { name: "arrow-drop-up", type: "filled" },
  minus: { name: "remove", type: "filled" },
  "minus-box": { name: "indeterminate-check-box", type: "filled" },
  "minus-box-outline": { name: "indeterminate-check-box", type: "outlined" },
  "minus-circle": { name: "remove-circle", type: "filled" },
  "minus-circle-outline": { name: "remove-circle", type: "outlined" },
  monitor: { name: "desktop-windows", type: "filled" },
  "open-in-new": { name: "open-in-new", type: "filled" },
  "page-first": { name: "first-page", type: "filled" },
  "page-last": { name: "last-page", type: "filled" },
  paperclip: { name: "attach-file", type: "filled" },
  pause: { name: "pause", type: "filled" },
  pencil: { name: "edit", type: "filled" },
  phone: { name: "phone", type: "filled" },
  pin: { name: "push-pin", type: "filled" },
  play: { name: "play-arrow", type: "filled" },
  plus: { name: "add", type: "filled" },
  "plus-box": { name: "add-box", type: "filled" },
  "plus-box-outline": { name: "add-box", type: "outlined" },
  "plus-circle": { name: "add-circle", type: "filled" },
  "plus-circle-outline": { name: "add-circle", type: "outlined" },
  power: { name: "power-settings-new", type: "filled" },
  printer: { name: "print", type: "filled" },
  react: { name: "react", type: "filled" },
  "real-estate": { name: "real-estate", type: "filled" },
  redo: { name: "redo", type: "filled" },
  refresh: { name: "refresh", type: "filled" },
  reply: { name: "reply", type: "filled" },
  "reply-all": { name: "reply-all", type: "filled" },
  "road-variant": { name: "road-variant", type: "filled" },
  roae: { name: "roae", type: "filled" },
  school: { name: "school", type: "filled" },
  send: { name: "send", type: "filled" },
  "sentiment-dissatisfied": { name: "sentiment-dissatisfied", type: "filled" },
  "sentiment-satisfied": { name: "sentiment-satisfied", type: "filled" },
  "sentiment-satisfied-alt": { name: "sentiment-satisfied-alt", type: "filled" },
  "sentiment-very-dissatisfied": { name: "sentiment-very-dissatisfied", type: "filled" },
  "sentiment-very-satisfied": { name: "sentiment-very-satisfied", type: "filled" },
  server: { name: "server", type: "filled" },
  settings: { name: "settings", type: "filled" },
  share: { name: "share-variant", type: "filled" },
  "shield-half-full": { name: "security", type: "filled" },
  "shuffle-variant": { name: "shuffle", type: "filled" },
  sitemap: { name: "sitemap", type: "filled" },
  sort: { name: "sort-variant", type: "filled" },
  "sort-ascending": { name: "sort-ascending-variant", type: "filled" },
  "sort-descending": { name: "sort-descending-variant", type: "filled" },
  square: { name: "square-variant", type: "filled" },
  "square-outline": { name: "square-variant", type: "outlined" },
  star: { name: "star", type: "filled" },
  "star-half": { name: "star-half", type: "filled" },
  "star-outline": { name: "star-outline", type: "filled" },
  // star-outlined from filled actually looks better
  sync: { name: "sync", type: "filled" },
  table: { name: "table", type: "filled" },
  tag: { name: "local-offer", type: "filled" },
  "tag-multiple": { name: "tag-multiple", type: "filled" },
  "thumb-down": { name: "thumb-down", type: "filled" },
  "thumb-up": { name: "thumb-up", type: "filled" },
  timer: { name: "timer", type: "filled" },
  "timer-off": { name: "timer-off", type: "filled" },
  "toggle-switch": { name: "toggle-on", type: "filled" },
  "toggle-switch-off": { name: "toggle-off", type: "filled" },
  tune: { name: "tune", type: "filled" },
  undo: { name: "undo", type: "filled" },
  upload: { name: "upload", type: "filled" },
  "vector-polyline": { name: "vector-polyline", type: "filled" },
  "view-column": { name: "view-column", type: "filled" },
  "view-list": { name: "view-list", type: "filled" },
  "window-maximize": { name: "window-maximize", type: "filled" },
  "window-minimize": { name: "window-minimize", type: "filled" },
  "window-restore": { name: "window-restore", type: "filled" },
  wrench: { name: "build", type: "filled" }
};

// components/icon-font/common/src/legacy/v11-to-v12-icon-mapping.ts
var solidMap = {
  "align-center": "format-align-center",
  "align-left": "format-align-left",
  "align-right": "format-align-right",
  at: "at",
  "angle-double-down": "chevron-double-down",
  "angle-double-left": "chevron-double-left",
  "angle-double-right": "chevron-double-right",
  "angle-double-up": "chevron-double-up",
  "angle-down": "chevron-down",
  "angle-left": "chevron-left",
  "angle-right": "chevron-right",
  "angle-up": "chevron-up",
  "arrow-down": "arrow-down",
  "arrow-left": "arrow-left",
  "arrow-right": "arrow-right",
  "arrow-up": "arrow-up",
  "arrows-alt": "arrow-all",
  "arrows-alt-h": "arrow-left-right",
  "arrows-alt-v": "arrow-up-down",
  ban: "cancel",
  bars: "menu",
  bell: "bell",
  bolt: "flash",
  book: "book",
  bookmark: "bookmark",
  briefcase: "briefcase",
  bug: "bug",
  bullseye: "bullseye",
  calculator: "calculator",
  calendar: "calendar-blank",
  "calendar-minus": "calendar-minus",
  "calendar-plus": "calendar-plus",
  camera: "camera",
  "caret-down": "menu-down",
  "caret-left": "menu-left",
  "caret-right": "menu-right",
  "caret-up": "menu-up",
  "chart-area": "chart-areaspline",
  "chart-bar": "chart-bar",
  "chart-line": "chart-line",
  "chart-pie": "chart-pie",
  check: "check",
  "check-circle": "checkbox-marked-circle",
  "check-square": "checkbox-marked",
  "chevron-down": "chevron-down",
  "chevron-left": "chevron-left",
  "chevron-right": "chevron-right",
  "chevron-up": "chevron-up",
  circle: "circle",
  clipboard: "clipboard",
  clock: "clock",
  "cloud-download-alt": "cloud-download",
  "cloud-upload-alt": "cloud-upload",
  code: "code-tags",
  cog: "settings",
  columns: "view-column",
  comment: "comment",
  comments: "comment-multiple",
  copy: "file-multiple",
  "credit-card": "credit-card",
  database: "database",
  desktop: "monitor",
  "dollar-sign": "currency-usd",
  download: "download",
  edit: "file-document-edit-outline",
  "ellipsis-h": "dots-horizontal",
  "ellipsis-v": "dots-vertical",
  envelope: "email",
  "euro-sign": "currency-eur",
  exclamation: "exclamation",
  "exclamation-circle": "alert-circle",
  "exclamation-circle-outline": "alert-circle-outline",
  "exclamation-triangle": "alert",
  "expand-arrows-alt": "arrow-expand-all",
  "external-link-alt": "open-in-new",
  eye: "eye",
  "eye-slash": "eye-off",
  flag: "flag",
  flask: "flask",
  file: "file",
  "file-alt": "file-document",
  "file-code": "file-code",
  "file-image": "file-image",
  "file-pdf": "file-pdf",
  filter: "filter",
  folder: "folder",
  "folder-open": "folder-open",
  heart: "heart",
  home: "home",
  image: "image",
  images: "image-multiple",
  inbox: "inbox",
  industry: "factory",
  info: "information-outline",
  "info-circle": "information",
  keyboard: "keyboard",
  lightbulb: "lightbulb",
  list: "format-list-bulleted-square",
  "list-alt": "format-list-bulleted",
  "list-ol": "format-list-numbered",
  link: "link",
  lock: "lock",
  "lock-open": "lock-open",
  magic: "auto-fix",
  "map-marker-alt": "map-marker",
  "mobile-alt": "cellphone",
  "mouse-pointer": "cursor-default",
  "paint-brush": "brush",
  "paper-plane": "send",
  paperclip: "paperclip",
  pause: "pause",
  "pencil-alt": "pencil",
  phone: "phone",
  play: "play",
  plus: "plus",
  "minus-circle": "minus-circle",
  minus: "minus",
  "plus-circle": "plus-circle",
  print: "printer",
  "project-diagram": "vector-polyline",
  "pound-sign": "currency-gbp",
  "power-off": "power",
  question: "help",
  "question-circle": "help-circle",
  "quote-right": "format-quote-close",
  random: "shuffle-variant",
  redo: "redo",
  reply: "reply",
  "reply-all": "reply-all",
  road: "road-variant",
  "ruble-sign": "currency-rub",
  "rupee-sign": "currency-inr",
  save: "content-save",
  search: "magnify",
  "search-minus": "magnify-minus-outline",
  "search-plus": "magnify-plus-outline",
  server: "server",
  share: "share",
  "shield-alt": "shield-half-full",
  "sign-in-alt": "login",
  "sign-out-alt": "logout",
  sitemap: "sitemap",
  "sliders-h": "tune",
  // 'space-shuttle': '',
  spinner: "loading",
  sort: "sort",
  "sort-down": "sort-descending",
  "sort-up": "sort-ascending",
  square: "square",
  star: "star",
  sync: "sync",
  table: "table",
  tag: "tag",
  tags: "tag-multiple",
  th: "grid",
  "th-large": "grid-large",
  "th-list": "view-list",
  thumbtack: "pin",
  "thumbs-down": "thumb-down",
  "thumbs-up": "thumb-up",
  times: "close",
  "times-circle": "close-circle",
  trash: "delete",
  undo: "undo",
  unlink: "link-off",
  upload: "upload",
  user: "account",
  users: "account-group",
  "window-maximize": "window-maximize",
  "window-minimize": "window-minimize",
  "window-restore": "window-restore",
  "window-close": "close-box",
  "won-sign": "currency-krw",
  wrench: "wrench",
  "yen-sign": "currency-jpy"
};
var regularMap = {
  bookmark: "bookmark-outline",
  square: "square-outline",
  circle: "circle-outline",
  heart: "heart-outline",
  clock: "clock-outline",
  calendar: "calendar-blank",
  "window-maximize": "window-maximize",
  "window-minimize": "window-minimize",
  "window-restore": "window-restore"
};
var brandsMap = {
  angular: "angular",
  react: "react"
};
var aliasMap = {
  // from JSI
  "gi-pencil-square-o": "file-document-edit-outline",
  repeat: "redo",
  "external-link": "open-in-new",
  "file-text-o": "file-document",
  "lightbulb-o": "lightbulb",
  mobile: "cellphone",
  refresh: "sync",
  remove: "close",
  pencil: "pencil",
  "flag-o": "flag",
  "trash-o": "delete",
  warning: "alert",
  "clock-o": "clock",
  "arrows-h": "arrow-left-right",
  "arrows-v": "arrow-up-down",
  "folder-open-o": "folder-open",
  electricity: "flash",
  // from goldman brands
  aspen: "aspen",
  "deal-harbor": "deal-harbor",
  "honest-dollar": "honest-dollar",
  lithium: "lithium",
  roae: "roae"
};
var v11ToV12IconMapping = {
  solid: {
    icons: solidMap,
    prefix: "gi"
  },
  regular: {
    icons: regularMap,
    prefix: "gir"
  },
  brands: {
    icons: brandsMap,
    prefix: "gib"
  },
  aliases: {
    icons: aliasMap,
    prefix: "gi"
  }
};

// components/icon-font/common/src/legacy/resolve-v12-icon-name.ts
var legacyAllIconMappings = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, v11ToV12IconMapping.solid.icons), v11ToV12IconMapping.regular.icons), v11ToV12IconMapping.brands.icons), v11ToV12IconMapping.aliases.icons);
function legacyResolveV12IconName(iconName) {
  return legacyAllIconMappings[iconName] || iconName;
}

// components/icon-font/common/src/resolve-icon-from-v12.ts
function resolveIconFromV12Name(v12IconName) {
  return v12ToDesignSystemIconMapping[v12IconName];
}
function resolveIconFromLegacyV12Name(legacyName) {
  return resolveIconFromV12Name(legacyResolveV12IconName(legacyName));
}

// components/icon-font/common/src/icon-element-component.ts
import { setAttributes } from "@gs-ux-uitoolkit-common/shared";
import { lightTheme } from "@gs-ux-uitoolkit-common/theme";
var IconElementComponent = class {
  constructor(props) {
    this.props = props;
    if (!props.name) {
      throw new Error(
        "<IconElementComponent /> error: 'name' input is required, please provide one!"
      );
    }
  }
  render(containerEl) {
    const {
      size = defaultIconProps.size,
      spin = false,
      pulse = false,
      name,
      className,
      classes: overrideClasses,
      attributes,
      type = defaultIconProps.type,
      theme = lightTheme
    } = this.props;
    if (this.iconEl === void 0) {
      const iconContent = getIconCodePoint(this.props);
      const fontFamily = resolveFontFamily(this.props);
      const cssClasses = iconStyleSheet.mount(this, {
        theme,
        fontFamily,
        size,
        type,
        spin,
        pulse,
        loading: false
      });
      this.iconEl = document.createElement("span");
      setAttributes(this.iconEl, __spreadValues({
        "data-gs-uitk-component": "icon",
        role: "img",
        "data-size": size,
        "data-spin": spin ? "true" : "false",
        "data-pulse": pulse ? "true" : "false",
        "aria-label": getAriaLabel(name),
        class: getIconClassNames({ name, cssClasses, className, overrideClasses })
      }, attributes));
      const contentEl = document.createElement("span");
      setAttributes(contentEl, {
        "data-cy": "gs-uitk-icon__content",
        role: "img",
        "aria-hidden": "true",
        class: getIconContentClassNames({ cssClasses, overrideClasses })
      });
      contentEl.innerHTML = iconContent;
      this.iconEl.appendChild(contentEl);
    }
    containerEl.appendChild(this.iconEl);
  }
  destroy() {
    var _a;
    iconStyleSheet.unmount(this);
    (_a = this.iconEl) == null ? void 0 : _a.remove();
  }
};

// components/icon-font/common/src/generated-legacy-snapshot/v12-icon-set.ts
var legacyV12IconSet = [
  "account",
  "account-group",
  "alert",
  "alert-circle",
  "alert-circle-outline",
  "alert-outline",
  "angular",
  "arrow-all",
  "arrow-down",
  "arrow-expand-all",
  "arrow-left",
  "arrow-left-right",
  "arrow-right",
  "arrow-up",
  "arrow-up-down",
  "aspen",
  "at",
  "auto-fix",
  "bell",
  "book",
  "bookmark",
  "bookmark-outline",
  "briefcase",
  "brush",
  "bug",
  "bullseye",
  "calculator",
  "calendar-blank",
  "calendar-minus",
  "calendar-plus",
  "camera",
  "cancel",
  "cellphone",
  "chart-areaspline",
  "chart-bar",
  "chart-line",
  "chart-pie",
  "check",
  "check-circle-outline",
  "checkbox-marked",
  "checkbox-marked-circle",
  "chevron-double-down",
  "chevron-double-left",
  "chevron-double-right",
  "chevron-double-up",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "circle",
  "circle-outline",
  "clipboard",
  "clock",
  "clock-outline",
  "close",
  "close-box",
  "close-circle",
  "cloud-download",
  "cloud-upload",
  "code-tags",
  "comment",
  "comment-multiple",
  "content-save",
  "credit-card",
  "currency-eur",
  "currency-gbp",
  "currency-inr",
  "currency-jpy",
  "currency-krw",
  "currency-rub",
  "currency-usd",
  "cursor-default",
  "database",
  "deal-harbor",
  "delete",
  "dots-horizontal",
  "dots-vertical",
  "download",
  "email",
  "exclamation",
  "eye",
  "eye-off",
  "factory",
  "file",
  "file-code",
  "file-document",
  "file-document-edit-outline",
  "file-image",
  "file-multiple",
  "file-pdf",
  "filter",
  "flag",
  "flash",
  "flask",
  "folder",
  "folder-account",
  "folder-open",
  "format-align-center",
  "format-align-left",
  "format-align-right",
  "format-bold",
  "format-italic",
  "format-list-bulleted",
  "format-list-bulleted-square",
  "format-list-numbered",
  "format-quote-close",
  "format-underline",
  "grid",
  "grid-large",
  "heart",
  "heart-outline",
  "help",
  "help-circle",
  "history",
  "home",
  "honest-dollar",
  "image",
  "image-multiple",
  "inbox",
  "information",
  "information-outline",
  "information-variant",
  "keyboard",
  "lightbulb",
  "link",
  "link-off",
  "lithium",
  "loading",
  "lock",
  "lock-open",
  "login",
  "logout",
  "magnify",
  "magnify-minus-outline",
  "magnify-plus-outline",
  "map-marker",
  "menu",
  "menu-down",
  "menu-left",
  "menu-right",
  "menu-up",
  "minus",
  "minus-box",
  "minus-box-outline",
  "minus-circle",
  "minus-circle-outline",
  "monitor",
  "open-in-new",
  "page-first",
  "page-last",
  "paperclip",
  "pause",
  "pencil",
  "phone",
  "pin",
  "play",
  "plus",
  "plus-box",
  "plus-box-outline",
  "plus-circle",
  "plus-circle-outline",
  "power",
  "printer",
  "react",
  "real-estate",
  "redo",
  "refresh",
  "reply",
  "reply-all",
  "road-variant",
  "roae",
  "school",
  "send",
  "sentiment-dissatisfied",
  "sentiment-satisfied",
  "sentiment-satisfied-alt",
  "sentiment-very-dissatisfied",
  "sentiment-very-satisfied",
  "server",
  "settings",
  "share",
  "shield-half-full",
  "shuffle-variant",
  "sitemap",
  "sort",
  "sort-ascending",
  "sort-descending",
  "square",
  "square-outline",
  "star",
  "star-half",
  "star-outline",
  "sync",
  "table",
  "tag",
  "tag-multiple",
  "thumb-down",
  "thumb-up",
  "timer",
  "timer-off",
  "toggle-switch",
  "toggle-switch-off",
  "tune",
  "undo",
  "upload",
  "vector-polyline",
  "view-column",
  "view-list",
  "window-maximize",
  "window-minimize",
  "window-restore",
  "wrench"
];

// components/icon-font/common/src/legacy/v11-icon-set.ts
var solid = [
  "align-center",
  "align-left",
  "align-right",
  "angle-double-down",
  "angle-double-left",
  "angle-double-right",
  "angle-double-up",
  "angle-down",
  "angle-left",
  "angle-right",
  "angle-up",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "arrows-alt-h",
  "arrows-alt-v",
  "arrows-alt",
  "at",
  "ban",
  "bars",
  "bell",
  "bolt",
  "book",
  "bookmark",
  "briefcase",
  "bug",
  "bullseye",
  "calculator",
  "calendar-minus",
  "calendar-plus",
  "calendar",
  "camera",
  "caret-down",
  "caret-left",
  "caret-right",
  "caret-up",
  "chart-area",
  "chart-bar",
  "chart-line",
  "chart-pie",
  "check-circle",
  "check-square",
  "check",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "circle",
  "clipboard",
  "clock",
  "cloud-download-alt",
  "cloud-upload-alt",
  "code",
  "cog",
  "columns",
  "comment",
  "comments",
  "copy",
  "credit-card",
  "database",
  "desktop",
  "dollar-sign",
  "download",
  "edit",
  "ellipsis-h",
  "ellipsis-v",
  "envelope",
  "euro-sign",
  "exclamation-circle-outline",
  "exclamation-circle",
  "exclamation-triangle",
  "exclamation",
  "expand-arrows-alt",
  "external-link-alt",
  "eye-slash",
  "eye",
  "file-alt",
  "file-code",
  "file-image",
  "file-pdf",
  "file",
  "filter",
  "flag",
  "flask",
  "folder-open",
  "folder",
  "heart",
  "home",
  "image",
  "images",
  "inbox",
  "industry",
  "info-circle",
  "info",
  "keyboard",
  "lightbulb",
  "link",
  "list-alt",
  "list-ol",
  "list",
  "lock-open",
  "lock",
  "magic",
  "map-marker-alt",
  "minus-circle",
  "minus",
  "mobile-alt",
  "mouse-pointer",
  "paint-brush",
  "paper-plane",
  "paperclip",
  "pause",
  "pencil-alt",
  "phone",
  "play",
  "plus-circle",
  "plus",
  "pound-sign",
  "power-off",
  "print",
  "project-diagram",
  "question-circle",
  "question",
  "quote-right",
  "random",
  "redo",
  "reply-all",
  "reply",
  "road",
  "ruble-sign",
  "rupee-sign",
  "save",
  "search-minus",
  "search-plus",
  "search",
  "server",
  "share",
  "shield-alt",
  "sign-in-alt",
  "sign-out-alt",
  "sitemap",
  "sliders-h",
  "sort-down",
  "sort-up",
  "sort",
  "space-shuttle",
  "spinner",
  "square",
  "star",
  "sync",
  "table",
  "tag",
  "tags",
  "th-large",
  "th-list",
  "th",
  "thumbs-down",
  "thumbs-up",
  "thumbtack",
  "times-circle",
  "times",
  "trash",
  "undo",
  "unlink",
  "upload",
  "user",
  "users",
  "window-close",
  "window-maximize",
  "window-minimize",
  "window-restore",
  "won-sign",
  "wrench",
  "yen-sign"
];
var regular = [
  "bookmark",
  "square",
  "circle",
  "heart",
  "clock",
  "calendar",
  "window-maximize",
  "window-minimize",
  "window-restore"
];
var brands = ["angular", "react"];
var goldmanIcons = ["honest-dollar"];
var v11IconSet = {
  solid: {
    icons: solid,
    prefix: "gi"
  },
  regular: {
    icons: regular,
    prefix: "gir"
  },
  brands: {
    icons: brands,
    prefix: "gib"
  },
  "goldman icons": {
    icons: goldmanIcons,
    prefix: "gi"
  }
};
export {
  FontLoadingStore,
  IconElementComponent,
  customFilledIcons,
  customOutlinedIcons,
  defaultIconProps,
  getAriaLabel,
  getIconClassNames,
  getIconCodePoint,
  getIconContentClassNames,
  getIconStyles,
  getLoadingStyles,
  getPulseStyles,
  getSpinStyles,
  iconFontFamilies,
  iconFontSizes,
  iconSizes,
  iconStyleSheet,
  iconTypes,
  injectIconFonts,
  legacyResolveV12IconName,
  legacyV12IconSet,
  materialDesignIconFonts,
  resolveFontFamily,
  resolveIconFont,
  resolveIconFromLegacyV12Name,
  resolveIconFromV12Name,
  resolveIconFromV16IconName,
  resolveIconFromV17IconName,
  resolveIconName,
  statusIcons,
  v11IconSet,
  v11ToV12IconMapping
};
//# sourceMappingURL=index.mjs.map
